/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Pain_EmptyInputs */

const en_us2_profile_pain_empty = /** @type {(inputs: Profile_Pain_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pain logged. If something hurts, tell us here and the plan adapts.`)
};

const pt_br2_profile_pain_empty = /** @type {(inputs: Profile_Pain_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma dor registrada. Se algo doer, conte aqui e o plano se adapta.`)
};

const es_419_profile_pain_empty = /** @type {(inputs: Profile_Pain_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay dolores registrados. Si algo te duele, cuéntanos aquí y el plan se adapta.`)
};

const pt_pt2_profile_pain_empty = /** @type {(inputs: Profile_Pain_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma dor registada. Se algo doer, conta-nos aqui e o plano adapta-se.`)
};

const fr_fr2_profile_pain_empty = /** @type {(inputs: Profile_Pain_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune douleur signalée. Si quelque chose te fait mal, dis-le ici et le programme s'adapte.`)
};

const de_de2_profile_pain_empty = /** @type {(inputs: Profile_Pain_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Schmerzen eingetragen. Wenn etwas wehtut, sag es uns hier, und der Plan passt sich an.`)
};

const it_it2_profile_pain_empty = /** @type {(inputs: Profile_Pain_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dolore registrato. Se qualcosa fa male, dillo qui e la scheda si adatta.`)
};

/**
* | output |
* | --- |
* | "No pain logged. If something hurts, tell us here and the plan adapts." |
*
* @param {Profile_Pain_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_pain_empty = /** @type {((inputs?: Profile_Pain_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Pain_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_pain_empty(inputs)
	if (locale === "es-419") return es_419_profile_pain_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_pain_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_pain_empty(inputs)
	if (locale === "de-DE") return de_de2_profile_pain_empty(inputs)
	if (locale === "it-IT") return it_it2_profile_pain_empty(inputs)
	return en_us2_profile_pain_empty(inputs)
});
export { profile_pain_empty as "profile.pain_empty" }